<template>
    <app-view id="app" @ready="ready">
        <template slot="logo">
            <a class="logo" href="#/">logo</a>
        </template>
        <template slot="account">
            <veui-icon name="user-circle"/>
        </template>
        <template slot="afterAccount">
            <veui-dropdown ui="link" :label="userName">
                <veui-option v-if="store.isPM && store.isAdminPage">
                    <veui-link ui="link" class="muse-app-link" to="/client/index.html" native>客户端</veui-link>
                </veui-option>
                <veui-option v-if="store.isPM && store.isClientPage">
                    <veui-link ui="link" class="muse-app-link" to="/admin/index.html" native>管理端</veui-link>
                </veui-option>
                <veui-option class="veui-option exit-btn" @click="handleLogout">
                    <veui-icon name="sign-out"/>
                </veui-option>
            </veui-dropdown>
        </template>
    </app-view>
</template>

<script>
import 'veui-theme-one-icons/sign-out';
import 'veui-theme-one-icons/user-circle';
import AppView from '@baidu/ve-ria/views/AppView';
import AppModel from './MusesAppModel';
import createView from '@baidu/ve-ria/views/createView';
import Vue from 'vue';
import {Icon, Dropdown, Option, Link} from 'veui';
import {each} from 'lodash';
import * as filters from '@/common/filters';
import validators from '@/common/validators';
import globalConfig from 'veui/managers/config';
import {monitorSession} from '@/common/utils';

function registerGlobalFilters(Vue, config) {
    each(config, (conf, name) => Vue.filter(name, conf));
}
registerGlobalFilters(Vue, filters);

Vue.mixin({
    data() {
        return {
            validatorMap: Object.freeze(validators)
        };
    }
});

export default createView(AppView, AppModel, {
    name: 'muses-app',
    components: {
        'veui-icon': Icon,
        'veui-dropdown': Dropdown,
        'veui-option': Option,
        'veui-link': Link
    },
    computed: {
        userName() {
            // todo: 有了session api 直接返回global.session.visitor.userName
            return this.global.session && this.global.session.visitor.userName || '匿名用户';
        },
        options() {
            // todo 根据用户权限控制options
            return {
                hasClient: true,
                hasAdmin: true
            };
        }
    },
    created() {
        globalConfig.set('uploader.requestMode', 'iframe');
        globalConfig.set('uploader.iframeMode', 'callback');
        globalConfig.set('uploader.callbackNamespace', 'esuiShowUploadResult');
        this.store.setPageInfo();
        // cas session 30 min 过期
        this.unmonitorSession = monitorSession(30 * 60 * 1000);
    },
    methods: {
        ready(session) {
            this.$emit('ready', session);
            // ready时调用，防止user未初始化的空指针错误。
            this.store.setUserInfo();
        },
        handleLogout() {
            let form = document.createElement('form');

            form.method = 'POST';
            form.style.display = 'none';
            form.action = this.store.logoutUrl;
            document.body.appendChild(form);
            form.submit();
            return form;
        }
    },
    beforeDestroy() {
        if (typeof this.unmonitorSession === 'function') {
            this.unmonitorSession();
        }
    }
});
</script>

<style lang="less">
.veui-option {
    .muse-app-link {
        display: block;
    }
}
</style>
